function copyURI(evt) {
  evt.preventDefault();
  navigator.clipboard.writeText(window.location.href);
}

const copyLinks = document.querySelectorAll(".copy-btn");

for (const copyLink of copyLinks) {
  copyLink.addEventListener("click", copyURI);
}

function saveArticleAsHTML() {
  const articleContent = document.querySelector(
    ".article-template .container",
  ).innerHTML;

  const fullHtml = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>${document.title}</title>
      <style>
        body { font-family: sans-serif; line-height: 1.6; max-width: 800px; margin: 40px auto; padding: 0 20px; }
        img { max-width: 100%; height: auto; position: relative; }
        img::after { content: ""; display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #ffffff; }
        .breadcrumb, .article-template__footer { display: none !important; }
        .article-template__title, .article-template__posttitle { margin: 1em 0; font-weight: bold; }
      </style>
    </head>
    <body>
      ${articleContent}
    </body>
    </html>
  `;

  const blob = new Blob([fullHtml], { type: "text/html" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "article.html";

  link.click();

  URL.revokeObjectURL(link.href);
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("DOMContentLoaded");
  const shareButton = document.querySelector(".article-template__button-share");
  const shareBlock = document.querySelector(".share-buttons-simple");

  if (shareButton && shareBlock) {
    shareButton.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      shareBlock.classList.toggle("is-active");
    });

    document.addEventListener("click", function (event) {
      if (!shareBlock.contains(event.target)) {
        shareBlock.classList.remove("is-active");
      }
    });
  }
});
